"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));
var _i18n = require("../../../i18n");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
var _PanelBody = _interopRequireDefault(require("./PanelBody"));
var _DetailsMessage = _interopRequireDefault(require("./DetailsMessage"));
var _PanelMessage = _interopRequireDefault(require("./PanelMessage"));
var _hooks = require("../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgressSpinnerPanel = () => {
  const {
    T
  } = (0, _i18n.useTranslation)();
  const {
    reportService,
    reportType,
    reportFormat
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const {
    trackShowProgressView
  } = (0, _hooks.useTrackEvent)({
    reportService,
    reportType,
    reportFormat
  });
  (0, _hooks.useTrackLoadEvent)(trackShowProgressView);
  return /*#__PURE__*/_react.default.createElement(StyledPanelBody, null, /*#__PURE__*/_react.default.createElement(_alloyReactProgressRing.default, {
    size: _alloyReactProgressRing.default.SIZES.LARGE
  }), /*#__PURE__*/_react.default.createElement(_PanelMessage.default, {
    i18nKey: "notifications.reportPending"
  }), /*#__PURE__*/_react.default.createElement(GenerateReportDetails, null, T.translate('notifications.reportPendingDetails')));
};
const StyledPanelBody = (0, _styledComponents.default)(_PanelBody.default)`
  align-items: center;
  padding-top: 48px;
`;
const GenerateReportDetails = (0, _styledComponents.default)(_DetailsMessage.default)`
  margin: 14px -10px;
`;
var _default = exports.default = ProgressSpinnerPanel;